/* eslint-disable no-unused-vars */
import { useState, useRef, useEffect, lazy, Suspense } from "react";
import { motion } from "framer-motion";
import { FaSpinner } from "react-icons/fa";

import { styles } from "../styles";
import { trackButtonClick } from "../services/trackingService";
import WhatsAppCta from "./ui/WhatsAppCta";
import { WHATSAPP_MESSAGES } from "../constants/whatsapp";
const Particle = lazy(() => import("./ui/ParticleOriginal.jsx").then(m => ({ default: m.Particle })));

const HeroComponent = () => {
  const [isWideScreenDesktop, setIsWideScreenDesktop] = useState(false);
  const [isWideScreenMobile, setIsWideScreenMobile] = useState(true);
  const [shouldHideAvatar, setShouldHideAvatar] = useState(false);
  const [shouldHideAboutButton, setShouldHideAboutButton] = useState(false);
  const [isImageLoadedDesktop, setIsImageLoadedDesktop] = useState(false);
  const [isImageLoadedMobile, setIsImageLoadedMobile] = useState(false);
  const desktopImgRef = useRef(null);
  const mobileImgRef = useRef(null);

  useEffect(() => {
    if (desktopImgRef.current) desktopImgRef.current.setAttribute('fetchpriority', 'high');
    if (mobileImgRef.current) mobileImgRef.current.setAttribute('fetchpriority', 'high');
  }, []);

  const avatarSrc = "/avatar-2.webp";
  const avatarSrcSet = "/avatar-2-sm.webp 360w, /avatar-2.webp 600w";

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const shouldShowAvatarInNarrowDesktop = width > 1024 && width < 1200 && height < 650;

      setIsWideScreenDesktop(width > 1023 && height < 700);
      setIsWideScreenMobile((width > 600 && height < 700) || (width < 750 && height < 650));
      setShouldHideAvatar(
        (width >= 750 && width <= 1200) &&
          ((height >= 700 && height <= 850) || height <= 650) &&
          !shouldShowAvatarInNarrowDesktop
      );
      setShouldHideAboutButton(height < 450);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleImageLoadDesktop = () => {
    setIsImageLoadedDesktop(true);
  };

  const handleImageLoadMobile = () => {
    setIsImageLoadedMobile(true);
  };

  return (
    <section className="relative w-full h-screen mx-auto overflow-hidden">
      <div>
        <Suspense fallback={null}>
          <Particle />
        </Suspense>
      </div>
      <div className="container">
        <div
          className={`absolute lg:inset-0 inset-x-0 top-28 m-auto max-w-7xl ${
            styles.paddingX
          } flex flex-row gap-5 ${isWideScreenDesktop && "md:pt-20 md:pl-28"}`}
        >
          <div className="flex flex-col md:justify-center items-center xs:pt-0 xl:pb-20">
            <div className="w-7 h-7 rounded-full bg-[#1582C7]" />
            <div className="w-1 sm:h-80 h-60 violet-gradient" />
          </div>

          <div className="flex flex-col justify-center pb-28">
            <h1
              className={`${
                isWideScreenDesktop ? "text-[30px]" : styles.heroHeadText
              } text-10vh font-black text-foreground`}
            >
              ¡Hola! Soy <span className="text-[#1582C7] ">Guido</span>
            </h1>
            <p
              className={`${
                isWideScreenDesktop
                  ? "text-[14px] lg:text-[20px]"
                  : styles.heroSubText
              } mt-2 text-foreground-muted`}
            >
              Ingeniero en Sistemas<span className={`${isWideScreenDesktop ? "": "hidden sm:inline"}`}> de Información</span> <br />
              Desarrollo aplicaciones web y <br />
              aplicaciones móviles a medida
            </p>
            <div className="flex flex-wrap items-center gap-4 pt-6">
              <WhatsAppCta
                source="hero_whatsapp_cta"
                message={WHATSAPP_MESSAGES.hero}
                label="Hablar por WhatsApp"
                className="px-8 py-2"
              />
                <a
                  href="#proyectos"
                  onClick={() => trackButtonClick("hero_cta_projects", "hero")}
                  aria-label="Ir a la sección de proyectos"
                  className="hidden sm:inline-flex items-center justify-center rounded-full border border-sky-400/60 px-8 py-2 text-base font-semibold text-foreground transition-all duration-300 hover:border-sky-400 hover:bg-sky-400/10"
                >
                  Ver Proyectos
                </a>
            </div>
          </div>
          {!shouldHideAvatar && (
            <div className="hidden lg:flex absolute end-32 inset-y-0 items-center -translate-y-3">
              <div className="relative w-[46vh] h-[46vh] max-h-svh mx-auto">
                <div
                  className={`w-full h-full rounded-full p-[5px] bg-[radial-gradient(circle_at_30%_30%,rgba(186,230,253,0.95)_0%,rgba(56,189,248,0.92)_55%,rgba(2,132,199,0.88)_100%)] shadow-[0_0_28px_rgba(56,189,248,0.55)] transition-opacity duration-500 ${
                    isImageLoadedDesktop ? "opacity-100" : "opacity-0"
                  }`}
                >
                  <img
                    ref={desktopImgRef}
                    src={avatarSrc}
                    srcSet={avatarSrcSet}
                    sizes="(max-width: 1280px) 38vw, 28vw"
                    alt="Avatar de Guido Cohen Semag"
                    className={`object-cover object-[center_14%] rounded-full w-full h-full transition-opacity duration-500 ${
                      isImageLoadedDesktop ? "opacity-100" : "opacity-0"
                    }`}
                    onLoad={handleImageLoadDesktop}
                    loading="eager"
                    decoding="sync"
                  />
                </div>
                {!isImageLoadedDesktop && (
                  <div className="absolute inset-0 flex items-center justify-center">
                    <FaSpinner className="animate-spin text-blue-500 w-[8vh] h-[8vh] max-h-svh" />
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        {!shouldHideAvatar && !isWideScreenMobile && (
          <div
            className={`flex lg:hidden absolute bottom-36 inset-x-0 justify-center items-center`}
          >
            <div className="relative w-[32vh] h-[32vh]">
              <div
                className={`w-full h-full rounded-full p-[4px] bg-[radial-gradient(circle_at_30%_30%,rgba(186,230,253,0.95)_0%,rgba(56,189,248,0.92)_55%,rgba(2,132,199,0.88)_100%)] shadow-[0_0_22px_rgba(56,189,248,0.5)] transition-opacity duration-500 ${
                  isImageLoadedMobile ? "opacity-100" : "opacity-0"
                }`}
              >
                <img
                  ref={mobileImgRef}
                  src={avatarSrc}
                  srcSet={avatarSrcSet}
                  sizes="(max-width: 1024px) 48vw, 30vw"
                  alt="Avatar de Guido Cohen Semag"
                  className={`object-cover object-[center_14%] rounded-full w-full h-full transition-opacity duration-500 ${
                    isImageLoadedMobile ? "opacity-100" : "opacity-0"
                  }`}
                  onLoad={handleImageLoadMobile}
                  loading="eager"
                  decoding="sync"
                />
              </div>
              {!isImageLoadedMobile && (
                <div className="absolute inset-0 flex items-center justify-center">
                  <FaSpinner className="animate-spin text-blue-500 w-[8vh] h-[8vh]" />
                </div>
              )}
            </div>
          </div>
        )}
        {!shouldHideAboutButton && (
          <div className="absolute bottom-10 w-full flex justify-center items-center">
            <a href="#sobre-mi" aria-label="Ir a la sección Sobre mí">
              <div className="w-[35px] h-[64px] rounded-3xl border-4 border-secondary flex justify-center items-start p-2">
                <motion.div
                  animate={{
                    y: [0, 24, 0],
                  }}
                  transition={{
                    duration: 1.5,
                    repeat: Infinity,
                    repeatType: "loop",
                  }}
                  className="w-3 h-3 rounded-full bg-[#1582C7] mb-1"
                />
              </div>
            </a>
          </div>
        )}
      </div>
    </section>
  );
};

export const Hero = HeroComponent;
